import { connect } from "react-redux";
import React from "react";
import StripeUpgradeForm from "../../stripe-upgrade-form";
import * as actions from "../../../../actions/actions";

class EduBilling extends React.Component {
    handleSuccess = () => {
        let { user } = this.props;
        this.props.redirect(`/${user.username}/settings/billing/`);
    };

    render() {
        return (
            <span>
                <div
                    className="loginView"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <style>{`
                        .loginView .text-link,
                        .loginView .text-link:hover {
                            color: white
                        }
                        .billing-form input{
                            padding: 20px 42px 20px 20px;
                        }
                    `}</style>
                    <form
                        className="new-form dark-form billing-form plugin-form"
                        style={{
                            maxWidth: "600px",
                            margin: "0 auto"
                        }}
                    >
                        <StripeUpgradeForm
                            showThankYou
                            thankYouTitle="Thanks for your Edu subscription!"
                            onSuccess={this.handleSuccess}
                            planKey="edu-yearly"
                        >
                            {({ form, submitButton, error }) => (
                                <React.Fragment>
                                    <ol>
                                        <li>
                                            <h2 className="form-header font-medium">
                                                Payment Information
                                            </h2>
                                        </li>
                                        <li>{form}</li>
                                        <li className="footer margin-t-l">
                                            <div className="price-status">
                                                Total billed today{" "}
                                                <span id="dash" />{" "}
                                                <span className="cost-total">
                                                    $19.99
                                                </span>
                                            </div>

                                            <p className="when-you-are-billed">
                                                You will be charged now and
                                                yearly at this time when your
                                                account automatically renews.
                                                Cancel automatic renewal any
                                                time by going to your billing
                                                page.
                                            </p>
                                        </li>
                                    </ol>
                                    {submitButton}
                                    {error}
                                </React.Fragment>
                            )}
                        </StripeUpgradeForm>
                    </form>
                </div>
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;
    let { user } = state;

    return {
        host,
        user
    };
}

export default connect(
    mapStateToProps,
    {
        redirect: actions.redirect
    }
)(EduBilling);
